(function($) {

	$.fn.msxitreetable = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.msxitreetable.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            eOpts = $.extend( {}, eOpts, {collapse: translate('Collapse'), expand: translate('Expand')});

            var isTree = false;
                $this.find('tbody tr').each(function(){
                if($(this).data('tt-parent-id')) {
                    isTree = true;
                    return false;
                }
                return true;
            });

            if(isTree) {
                $this.treetable(eOpts);

                $this.find('tr.reveal-row').each(function(){
                    $this.treetable('reveal', $(this).data('tt-id'));
                });
            }

            $this.find('.expand-all').click(function(){
                $this.treetable('expandAll');
                return false;
            });

            $this.find('.collapse-all').click(function(){
                $this.treetable('collapseAll');
                return false;
            });

            $this.find('.reveal-level-2').click(function(){
                revealLevel(2);
                return false;
            });

            $this.find('.reveal-level-3').click(function(){
                revealLevel(3);
                return false;
            });

            $this.find('.reveal-level-4').click(function(){
                revealLevel(4);
                return false;
            });

            function revealLevel(level) {
                $this.find('.tree-row-' + level).each(function(){
                    if($(this).is('.expanded')) {
                        collapseBranch($(this).data('tt-id'));
                    }
                });
                $this.find('.tree-row-' + (level-1)).each(function(){
                    if(!$(this).is('.expanded')) {
                        $this.treetable('reveal', $(this).data('tt-id'));
                    }
                });
            }

            function collapseBranch(id) {
                // recursively collapse descendents
                $this.find('[data-tt-parent-id='+id+']').each(function(){ collapseBranch($(this).data('tt-id')); });
                $this.treetable('collapseNode', id);
            }
        });
	};
	//
	// plugin defaults
	//
	$.fn.msxitreetable.defaults = {
        expandable: true,
        clickableNodeNames: true,
        indent: 16
	};

})(jQuery);